import { render } from "./EditPaymentTerminalModal.vue?vue&type=template&id=b5e7b99a"
import script from "./EditPaymentTerminalModal.vue?vue&type=script&lang=js"
export * from "./EditPaymentTerminalModal.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__